'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
require('react');
var PropTypes = require('prop-types');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var variantTagTypes = ['h1', 'h2', 'h3', 'h4', 'p'];
var tagOverrideTypes = [].concat(variantTagTypes, ['h5', 'h6', 'b', 'i', 'strong', 'em', 'mark', 'small', 'del', 'ins', 'sub', 'sup', 'pre', 'blockquote', 'q', 'abbr', 'address', 'cite', 'code', 'dfn', 'span']);
var variantNames = ['hero', 'h1', 'h2', 'h3', 'h4', 'bodyL', 'bodyM', 'bodyS', 'bodyXS', 'complianceS', 'complianceXS'];
/**
 * This config is used as the single source of truth for our typography styles. It is used by the Typography component
 * and to generate styles in our global css to cover instances where our Typography component can't be used.
 */
var typographyConfig = {
  hero: {
    tag: 'h1',
    styles: {
      fontFamily: 'var(--font-family-headline)',
      fontSize: 'var(--font-size-xl)',
      lineHeight: 'var(--font-lineHeight-xl)',
      fontWeight: 'var(--font-weight-black)',
      margin: '0 0 var(--space-xy-small-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-l)',
      lineHeight: 'var(--font-lineHeight-l)',
      margin: '0 0 var(--space-xy-small-rem)'
    }
  },
  h1: {
    tag: 'h1',
    styles: {
      fontFamily: 'var(--font-family-headline)',
      fontSize: 'var(--font-size-xl)',
      lineHeight: 'var(--font-lineHeight-xl)',
      fontWeight: 'var(--font-weight-bold)',
      margin: '0 0 var(--space-xy-small-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-m)',
      lineHeight: 'var(--font-lineHeight-m)',
      margin: '0 0 var(--space-xy-small-rem)'
    }
  },
  h2: {
    tag: 'h2',
    styles: {
      fontFamily: 'var(--font-family-headline)',
      fontSize: 'var(--font-size-m)',
      lineHeight: 'var(--font-lineHeight-m)',
      fontWeight: 'var(--font-weight-bold)',
      margin: '0 0 var(--space-xy-small-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-s)',
      lineHeight: 'var(--font-lineHeight-s)',
      margin: '0 0 var(--space-xy-small-rem)'
    }
  },
  h3: {
    tag: 'h3',
    styles: {
      fontFamily: 'var(--font-family-headline)',
      fontSize: 'var(--font-size-s)',
      lineHeight: 'var(--font-lineHeight-s)',
      fontWeight: 'var(--font-weight-bold)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-xs)',
      lineHeight: 'var(--font-lineHeight-xs)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    }
  },
  h4: {
    tag: 'h4',
    styles: {
      fontFamily: 'var(--font-family-headline)',
      fontSize: 'var(--font-size-2xs)',
      lineHeight: 'var(--font-lineHeight-2xs)',
      fontWeight: 'var(--font-weight-bold)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-2xs)',
      lineHeight: 'var(--font-lineHeight-2xs)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    }
  },
  bodyL: {
    tag: 'p',
    styles: {
      fontFamily: 'var(--font-family-primary)',
      fontSize: 'var(--font-size-xs)',
      lineHeight: 'var(--font-lineHeight-xs)',
      fontWeight: 'var(--font-weight-regular)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-xs)',
      lineHeight: 'var(--font-lineHeight-xs)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    }
  },
  bodyM: {
    tag: 'p',
    styles: {
      fontFamily: 'var(--font-family-primary)',
      fontSize: 'var(--font-size-2xs)',
      lineHeight: 'var(--font-lineHeight-2xs)',
      fontWeight: 'var(--font-weight-regular)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-2xs)',
      lineHeight: 'var(--font-lineHeight-2xs)',
      margin: '0 0 var(--space-xy-xxSmall-rem)'
    }
  },
  bodyS: {
    tag: 'p',
    styles: {
      fontFamily: 'var(--font-family-primary)',
      fontSize: 'var(--font-size-3xs)',
      lineHeight: 'var(--font-lineHeight-3xs)',
      fontWeight: 'var(--font-weight-regular)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-3xs)',
      lineHeight: 'var(--font-lineHeight-3xs)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    }
  },
  bodyXS: {
    tag: 'p',
    styles: {
      fontFamily: 'var(--font-family-primary)',
      fontSize: 'var(--font-size-4xs)',
      lineHeight: 'var(--font-lineHeight-4xs)',
      fontWeight: 'var(--font-weight-regular)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-4xs)',
      lineHeight: 'var(--font-lineHeight-4xs)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    }
  },
  complianceS: {
    tag: 'p',
    styles: {
      fontFamily: 'var(--font-family-compliance)',
      fontSize: 'var(--font-size-3xs)',
      lineHeight: 'var(--font-lineHeight-3xs)',
      fontWeight: 'var(--font-weight-regular)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-3xs)',
      lineHeight: 'var(--font-lineHeight-3xs)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    }
  },
  complianceXS: {
    tag: 'p',
    styles: {
      fontFamily: 'var(--font-family-compliance)',
      fontSize: 'var(--font-size-4xs)',
      lineHeight: 'var(--font-lineHeight-4xs)',
      fontWeight: 'var(--font-weight-regular)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    },
    mobileStyles: {
      fontSize: 'var(--font-size-4xs)',
      lineHeight: 'var(--font-lineHeight-4xs)',
      margin: '0 0 var(--space-xy-xxxSmall-rem)'
    }
  }
};

/* eslint-disable max-len */
var _exp = function _exp() {
  return function (_ref) {
    var styles = _ref.variantConfig.styles;
    return styles.fontFamily;
  };
};
var _exp2 = function _exp2() {
  return function (_ref2) {
    var styles = _ref2.variantConfig.styles;
    return styles.fontSize;
  };
};
var _exp3 = function _exp3() {
  return function (_ref3) {
    var styles = _ref3.variantConfig.styles;
    return styles.lineHeight;
  };
};
var _exp4 = function _exp4() {
  return function (_ref4) {
    var styles = _ref4.variantConfig.styles;
    return styles.fontWeight;
  };
};
var _exp5 = function _exp5() {
  return function (_ref5) {
    var styles = _ref5.variantConfig.styles;
    return styles.margin;
  };
};
var _exp7 = function _exp7() {
  return function (_ref6) {
    var mobileStyles = _ref6.variantConfig.mobileStyles;
    return mobileStyles.fontSize;
  };
};
var _exp8 = function _exp8() {
  return function (_ref7) {
    var mobileStyles = _ref7.variantConfig.mobileStyles;
    return mobileStyles.lineHeight;
  };
};
var _exp9 = function _exp9() {
  return function (_ref8) {
    var mobileStyles = _ref8.variantConfig.mobileStyles;
    return mobileStyles.margin;
  };
};
var StyledTag = /*#__PURE__*/react.styled('p')({
  name: "StyledTag",
  "class": "s1t5dxhr",
  propsAsIs: false,
  vars: {
    "s1t5dxhr-0": [_exp()],
    "s1t5dxhr-1": [_exp2()],
    "s1t5dxhr-2": [_exp3()],
    "s1t5dxhr-3": [_exp4()],
    "s1t5dxhr-4": [_exp5()],
    "s1t5dxhr-5": [_exp7()],
    "s1t5dxhr-6": [_exp8()],
    "s1t5dxhr-7": [_exp9()]
  }
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var propTypes = {
  /** Typography variant. Defaults to 'bodyM'. */
  variant: PropTypes__default["default"].oneOf(variantNames),
  /** Optional tag to be used in place of default tag found in variant map. Ex. 'p', 'h2' etc. */
  tagOverride: PropTypes__default["default"].oneOf(tagOverrideTypes),
  /** A string of HTML that will get passed to the dangerouslySetInnerHTML React property */
  dangerousInnerHTML: PropTypes__default["default"].string,
  /** Overriding styles for this component is strongly discouraged and this prop should be used judiciously. Styles object passed to style attribute of typography element. */
  style: PropTypes__default["default"].object,
  /** String of classes passed to className attribute. */
  className: PropTypes__default["default"].string,
  /** String of id's passed to id attribute. */
  id: PropTypes__default["default"].string,
  /** Text to be wrapped */
  children: PropTypes__default["default"].node,
  /** Test id for unit testing */
  testId: PropTypes__default["default"].string
};
var Typography = function Typography(_ref) {
  var variant = _ref.variant,
    tagOverride = _ref.tagOverride,
    dangerousInnerHTML = _ref.dangerousInnerHTML,
    style = _ref.style,
    className = _ref.className,
    id = _ref.id,
    children = _ref.children,
    testId = _ref.testId;
  var variantConfig = variant ? typographyConfig[variant] : typographyConfig.bodyM;
  var tag = tagOverride || variantConfig.tag;
  return /*#__PURE__*/jsxRuntime.jsx(StyledTag, _objectSpread(_objectSpread({
    as: tag,
    variantConfig: variantConfig,
    style: style !== null && style !== void 0 ? style : undefined,
    className: className !== null && className !== void 0 ? className : undefined,
    id: id !== null && id !== void 0 ? id : undefined,
    "data-testid": testId || 'typography'
  }, dangerousInnerHTML && {
    dangerouslySetInnerHTML: {
      __html: dangerousInnerHTML
    }
  }), {}, {
    children: children
  }));
};
Typography.propTypes = propTypes;

exports.Typography = Typography;
exports.variantNames = variantNames;
